module.exports = __webpack_public_path__ + "static/media/cover-image-bicc.e6873181.png";